import { render, staticRenderFns } from "./onValidate-editor.vue?vue&type=template&id=63bf78e0&scoped=true"
import script from "./onValidate-editor.vue?vue&type=script&lang=js"
export * from "./onValidate-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf78e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63bf78e0')) {
      api.createRecord('63bf78e0', component.options)
    } else {
      api.reload('63bf78e0', component.options)
    }
    module.hot.accept("./onValidate-editor.vue?vue&type=template&id=63bf78e0&scoped=true", function () {
      api.rerender('63bf78e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onValidate-editor.vue"
export default component.exports